import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectQRScannerStatus = createSelector(
  [(store: RootState) => store.qrScanner.qrScannerStatus],
  (data) => data
);